module.exports = {"return":{"minions":{"maggie.bardels.me":"52:33:32:33:6b:f8:5c:1a:19:c6:43:1d:73:f7:04:35:61:31:81:a1:5d:ec:82:e4:2b:40:e4:8e:64:b5:2d:1f"}}}


//////////////////
// WEBPACK FOOTER
// ./src/fixtures/get_key.maggie.json
// module id = 1055
// module chunks = 0